var _defs, _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _text5, _text6, _text7, _rect4, _text8, _text9, _path, _rect5, _text0, _rect6, _text1, _text10, _text11, _text12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLookMenuUnreal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 260",
    width: 620,
    height: 260,
    role: "img",
    "aria-label": "Unreal Content Browser right-click menu on a material instance, with a Squarebit submenu containing Export Eye Look and Import Eye Look.",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .panel { fill: #11151c; }\n      .menu  { fill: #232b37; }\n      .hl    { fill: #22d3ee; fill-opacity: 0.14; }\n      .txt   { font-family: ui-sans-serif, system-ui, \"Segoe UI\", sans-serif; font-size: 13px; fill: #cbd5e1; }\n      .dim   { fill: #64748b; }\n      .accent{ fill: #22d3ee; }\n      .label { font-family: ui-sans-serif, system-ui, \"Segoe UI\", sans-serif; font-size: 11px; fill: #64748b; letter-spacing: .04em; }\n      .asset { fill: #1b212b; stroke: #334155; stroke-width: 1; }\n      .arrow { stroke: #64748b; stroke-width: 1.2; fill: none; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 620,
    height: 260,
    rx: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "asset",
    x: 20,
    y: 24,
    width: 86,
    height: 86,
    rx: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 20,
    y: 128
  }, "M_Eye_L_Inst")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 20,
    y: 146
  }, "Material Instance")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "menu",
    x: 124,
    y: 24,
    width: 212,
    height: 150,
    rx: 8
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 140,
    y: 48
  }, "Edit\u2026")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 140,
    y: 72
  }, "Rename")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 140,
    y: 96
  }, "Duplicate")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 140,
    y: 120
  }, "Asset Actions")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "txt dim",
    x: 312,
    y: 120
  }, "\u203A")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "hl",
    x: 132,
    y: 130,
    width: 196,
    height: 24,
    rx: 4
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 140,
    y: 147
  }, "Squarebit")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 312,
    y: 147
  }, "\u203A")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow",
    d: "M332 142 L350 142"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "menu",
    x: 352,
    y: 106,
    width: 244,
    height: 82,
    rx: 8
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 366,
    y: 126
  }, "SQUAREBIT EYE")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "hl",
    x: 360,
    y: 134,
    width: 228,
    height: 22,
    rx: 4
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "txt accent",
    x: 368,
    y: 150
  }, "Export Eye Look\u2026")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "txt",
    x: 368,
    y: 176
  }, "Import Eye Look\u2026")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 20,
    y: 222
  }, "Import applies to a material INSTANCE \u2014 never the master, which would move every eye.")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 20,
    y: 240
  }, ".json and .usda both read; textures are not re-pointed.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLookMenuUnreal);
export default __webpack_public_path__ + "static/media/eye-look-menu-unreal.738b4a93c2136641ac1244a0c8e54f8e.svg";
export { ForwardRef as ReactComponent };